import { useConfiguration } from '../../../../../../store/configurationStore';
import { MultiColumnRulesWithCategoriesSectionProps } from './types';

export const useMultiColumnRulesWithCategoriesSection = (
  props: MultiColumnRulesWithCategoriesSectionProps
) => {
  const { sectionId } = props;
  const { getValidationForSection } = useConfiguration();

  // Read validation from store
  const validationResult = getValidationForSection(sectionId);

  return {
    validationResult,
  };
};
